import React, { Component } from "react";
import {separationMapOptions,mapSeparationSteps, uploadFileInstruction, mapType, reviewInstruction} from '../../../utils/constants';
import Steps from '../../Steps/Steps';
import UploadFile from '../Components/UploadFile/UploadFile';
import MatchColumns from '../Components/MatchColumns/MatchColumns';
import Review from '../Components/Review/Review';
import MapColumns from '../Components/MapColumns/MapColumns';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import findIndex from 'lodash/findIndex';
import { deepClone } from "../../../utils/copyObject";
import axios from "../../../axios";
import * as url from "../../../utils/url";

export default class MapSeparation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType : 'unmapped-first',
      mapOptions: [],
      error:false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let options
    let {allSeparationMapping} = this.props.mapSeparation;
    const orgID = this.props.user.organizationId._id

    axios.get(url.getMasterListByCategory('SEPARATION')).then(({data}) => {
      const payload = data.data[0].docs;
      options = payload.map((i) => {
        const o = {};
        o.value = i._id;
        o.label = i.name;
        return o;
      });
      this.setState({
        mapOptions : options
      })
     


    })
  }

  handleFileUpload = (fields, data, file) => {
    
    const {matchedColumn} = this.props.mapSeparation;
    // console.log("fields : ",fields,"includes : ",file, '--', data);
    if(matchedColumn.length > 0) {
      if(!fields.includes(matchedColumn)) {
        this.props.onMatchColumn("");
      }
    }
    this.props.onProcessedFileUploadData(fields, data, file);
    this.props.nextStep();
  }

  handleMatchSeparationColumn = (matchedColumn) => {
    // matchedColumn=""
    let {rowData,allSeparationMapping} = this.props.mapSeparation;
    // console.log(matchedColumn);
    const {isRepeatFlow} = this.props;

    
    const uSep = Object.keys(groupBy(rowData,(r) => r[matchedColumn]));
    // console.log(uSep,isRepeatFlow)
    const uniqueSeparations = uSep.filter(e => e!=="null")
    this.props.onMatchColumn(matchedColumn);
    const orgID = this.props.user.organizationId._id
    let options = this.state.mapOptions

      if(isRepeatFlow) {
        axios.get(url.getExistingMappings(orgID)).then(({data}) => {
          const payload = data.data;
          let {mapping} = payload;
          // console.log('mppaing --- ', mapping)
          if(mapping.separation && mapping.separation.data ){
            allSeparationMapping=[]
            // console.log('inside')
            mapping.separation.data.map(e=>{
              let column = e.key
              let obj;
                e.values.map(c=>{
                  let cVal = find(options, {label:e.key})
                  // console.log('va--', cVal)
                  obj = {column:{value: cVal.value, label:e.key}, value: c, mapped:true}
                  return allSeparationMapping.push(obj)
                })
            })
          // console.log('all ---', allSeparationMapping)
          this.props.saveAllSeparationMapping(allSeparationMapping)  
  
          if(allSeparationMapping.length>0){
            const filteredMapping = uniqueSeparations.map((f) => {
              const found = find(allSeparationMapping,(o) => o.value === f);
              if(found) {
                return {
                  value : f,
                  column : found.column,
                  mapped:true
                }
              } else {
                return {
                  value : f,
                  column : '',
                  mapped:false
                }
              }
            })
           
            //  console.log(filteredMapping,'--',allSeparationMapping);
             let results = allSeparationMapping.concat(filteredMapping)
             let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
               if(e.column!==""){
                 let obj = {
                   value:e.value,
                   mapped: e.mapped,
                   column: {label:e.column!==""?e.column.label:"",value: e.column?e.column.value:""}
                 }
                 return obj
               } else {
                 let val = !e.value || e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
                 let obj = {
                   value:val,
                   mapped: false,
                   column: ""
                 }
                 return obj
               }
             })
             res = uniqBy(res, 'value')
             this.props.saveAllSeparationMapping(res);
             this.props.nextStep();
          } else {
            const mappingArray = sortBy(filter(uniqueSeparations,(g) => g != 'undefined').map((separation) => {
              const g = {};
              g.value = separation;
              g.column = ''
              return g;
            }),(o) => o.value);
            this.props.saveAllSeparationMapping(mappingArray);
            this.props.nextStep();
        }
      } else {
        const mappingArray = sortBy(filter(uniqueSeparations,(g) => g != 'undefined').map((separation) => {
          const g = {};
          g.value = separation;
          g.column = ''
          return g;
        }),(o) => o.value);
        this.props.saveAllSeparationMapping(mappingArray);
        this.props.nextStep();
      }
      })
    }else {
      const mappingArray = sortBy(filter(uniqueSeparations,(g) => g != 'undefined').map((separation) => {
        const g = {};
        g.value = separation;
        g.column = ''
        return g;
      }),(o) => o.value);
      this.props.saveAllSeparationMapping(mappingArray);
      this.props.nextStep();
    }
  }

  handleMapColumnContinue = () => {
    const {allSeparationMapping} = this.props.mapSeparation;

    const invalidRecords = filter(allSeparationMapping,(o) => o.mapped && !o.column && o.column!=="");
    // console.log('invalid ---', invalidRecords)
    if(invalidRecords.length>0){
      this.setState({error:"Please map previously mapped values"})
      return
    } else {
      this.setState({error:false})
        this.props.nextStep()
    }


    // if(invalid.length > 0) {
    //   return;
    // } else {
      // this.props.nextStep();
    // }
  }

  handleSeparationMapped = (separation,column) => {
    const {allSeparationMapping} = this.props.mapSeparation;
    const allSeparation = deepClone(allSeparationMapping);
    const i = findIndex(allSeparation,{value : separation.value});
    allSeparation.splice(i,1,{value:separation.value,column:column, mapped:separation.mapped})
    this.props.saveAllSeparationMapping(allSeparation);
  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    })
  }

  handleContinue = () => {
    let {allSeparationMapping} = this.props.mapSeparation;
    const {isRepeatFlow} = this.props;
    allSeparationMapping = filter(allSeparationMapping,(m)=> m.column)
    // console.log('pp-----', allSeparationMapping)
    const groupedMapping = groupBy(allSeparationMapping,(m) => m.column.value);
    // console.log(groupedMapping);
    let data = [];
    for(let key in groupedMapping) {
      // console.log(groupedMapping[key]);
      data.push({
        key : key,
        values : groupedMapping[key].map((o) => o.value)
      })
    }
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")
    // console.log(data);
    const {matchedColumn} = this.props.mapSeparation;
    // console.log(matchedColumn);
    const payload = {
      mappingType : "separation",
      columnName : matchedColumn,
      data : data
    }
    // console.log(payload);
    axios.post(url.saveMapping,payload).then(({data}) => {
      if(isRepeatFlow) {
        this.props.history.push({pathname : 'success',state : {type : 'separation'}});
        this.props.reset();
      } else {
        this.props.history.push('/setup/personal-details');
      }
    })
  }

  handleonSortChange = (sortType) => {
    this.setState({
      sortType : sortType
    });
  }

  handleSkipStep = () => {
    axios.post(url.skipStepFor('separation')).then(({data}) => {
      this.props.history.push('/setup/personal-details');
    })
  }

  render() {
    let {currentStep, allColumns, rowData, file, matchedColumn, allSeparationMapping} = this.props.mapSeparation;
    // console.log(allSeparationMapping);
    // console.log(this.props.mapSeparation);
    const {searchedTerm,sortType,mapOptions} = this.state;
    const {isRepeatFlow} = this.props;
    return (<div className={"mb30" + isRepeatFlow ? 'mt30' : 'mt70'}>
    <div className="map-gender-title mt30 mb30">Map Separation</div>
      <Steps steps={mapSeparationSteps} currentStep={currentStep} />
      {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.mapSeparation}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            type={mapType.separation}
            labelSize={4}
            labelText="File with Separation Information"
            allowedFileSize={20}
            uploadFileHint="(Only .csv files, maximum 20MB file size)"
            onFileUpload={this.handleFileUpload}
            onSkipStep={this.handleSkipStep}
            isRepeatFlow={isRepeatFlow}
          /> : 
          currentStep === 2 ?
            <MatchColumns
              goBack={this.props.goBack}
              top="mt40"
              instruction="Please match the column with employee separation information."
              csvFields = {allColumns}
              csvData = {rowData}
              type={mapType.separation}
              matchedColumns={matchedColumn!=="" ? [matchedColumn] : []}
              allowMoreColumnsMatch={false}
              mappingPositions={true}
              nextBtnTxt='Continue'
              onMatchedColumn={this.handleMatchSeparationColumn}
            /> : 
          currentStep === 3 ?
            <MapColumns
              allDataMapping={allSeparationMapping}
              mapOptions={mapOptions}
              type={mapType.separation}
              onRowMapped={this.handleSeparationMapped}
              nextStep={this.handleMapColumnContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              sortType={sortType}
              error={this.state.error}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              mapSelectPlaceholder= "Map to separation categories"
              optionTypeTxt="Separation"
              mappingTableHeader="Separation"
              searchBarPlaceholder="Search by separation"
              mappingSubHeaderTxt="Please map the separation information from your .csv to standardized separation categories."
            /> :
          currentStep === 4 ?
            <Review
              top="mt40"
              instruction={reviewInstruction.separation}
              goBack={this.props.goBack}
              nextBtnAction={this.handleContinue}
              type={mapType.separation}
              mapOptions={mapOptions}
              file={file}
              nextBtnTxt={isRepeatFlow ? 'Finish' : 'Next Step'}
              isRepeatFlow={isRepeatFlow}
              reviewHeading="These are your final selections for the mapping. "
              {...this.props}
            />:
             null
        }
    </div>);
  }
}